<template>
  <div class="setting-advanced-msg">
    <div class="setting-advanced-msg-num-tips" v-if="showMsgTips">
      <p>当前可用短信数量<span class="msg-leave-num">{{msgNum}}</span>条</p>
      <router-link to="/setting-advanced-msg-recharge" class="msg-to-recharge">立即充值</router-link>
      <svg-icon icon-class="close" class="msg-close-btn" @click.native="closeTips"></svg-icon>
    </div>
    <ul class="setting-advanced-tab-container module-item-style">
      <router-link :to="menu.path" tag="li" v-for="(menu, index) in tabbar" :class="$route.path == menu.path ? 'tabActived' : ''" :key="index">{{menu.meta.title}}</router-link>
      <router-link to="/setting-advanced-msg-recharge" tag="li" class="recharge-btn" v-if="currentRoute"><span class="wl-btn" >立即充值</span></router-link>
    </ul>
    <div class="setting-msg-content-container module-item-style">
      <transition name="fade-transform" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'setting-advanced-msg',
    data() {
      return {
        showMsgTips: true,
        msgNum: 0,
      }
    },
    computed:{
      tabbar(){
        let menu = []
        let currenMenuMatched = this.$route.matched
        this.$store.state.permission.addRoutes.map((item) => {
          if(item.name == 'layout'){
            item.children.map( subItem => {
              if(subItem.path == currenMenuMatched[1].path){
                subItem.children.map( subSubItem => {
                  if(subSubItem.path == currenMenuMatched[2].path){
                    subSubItem.children.map( subSunSubItem => {
                      if(subSunSubItem.path == currenMenuMatched[3].path){
                        menu = subSunSubItem.children
                      }
                    })
                  }
                })
              }
            })
          }
        })
        return menu
      },
      currentRoute(){
        let route = this.$route
        if(route.name == 'settingAdvancedMsgRecharge'){
          return false
        }else {
          return true
        }
      }
    },
    created(){
      this.getLeaveMsg()
    },
    mounted() {

    },
    methods: {
      closeTips(){
        this.showMsgTips = false
      },
      getLeaveMsg(){
        this.$http.getMsgNumAPI().then( res => {
          if(res.status == 1){
            this.msgNum = res.data.msgCount
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .setting-advanced-msg{
    .setting-advanced-msg-num-tips{
      border-radius: $mainBorderRadius;
      background-color: #fff2d7;
      border: 1px solid #ffdf9c;
      margin-bottom: 10px;
      line-height: 40px;
      font-size: 12px;
      color: #666;
      display: flex;
      padding: 0 19px;
      position: relative;
      .msg-leave-num{
        font-size: 14px;
        color: #ff4e00;
        font-weight: bold;
        padding: 0 5px;
      }
      .msg-to-recharge{
        color: #f0ad4e;
        cursor: pointer;
        margin-left: 12px;
      }
      .msg-close-btn{
        position: absolute;
        right: 0px;
        top: 50%;
        margin-top: -9px;
        cursor: pointer;
      }
    }
    .setting-advanced-tab-container{
      display: flex;
      padding: 24px 24px 17px;
      position: relative;
      li{
        margin-right: 40px;
        color: #333333;
        font-size: 12px;
        letter-spacing: 1.4px;
        cursor: pointer;
        padding-bottom: 7px;
      }
      .recharge-btn{
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -20px;
        margin-right: 0;
      }
    }

    .setting-msg-content-container{
      margin-top: 10px;
      padding: 22px;
    }
  }

</style>
